import React, { Fragment, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Header from "./Components/Header";
import SideBar from "./Components/SideBar";
import "./table.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
const theme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: `"primary-font"`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});
const App = props => {
  useEffect(() => {
    document.dir = "rtl";
  }, []);
  return (
    <Fragment>
      <Helmet>
        <link
          rel="stylesheet"
          href="/assets/vendors/select2/css/select2.min.css"
          type="text/css"
        />
        <link
          rel="stylesheet"
          href="/assets/vendors/datepicker-jalali/bootstrap-datepicker.min.css"
          type="text/css"
        />
        <link
          rel="stylesheet"
          href="/assets/vendors/clockpicker/bootstrap-clockpicker.min.css"
          type="text/css"
        />
        <link
          rel="stylesheet"
          href="/assets/vendors/bundle.css"
          type="text/css"
        />
        <link rel="stylesheet" href="/css/bootstrap-rtl.min.css" />
        <link rel="stylesheet" href="/font//fontawesome/css/all.css" />
        <link rel="stylesheet" href="/css/vazir.css" />
        <link rel="stylesheet" href="/assets/css/custom.css" type="text/css" />
        <link rel="stylesheet" href="/assets/css/app.css" />
        <link rel="stylesheet" href="/css/web/ClassManager.css" />
        <link
          rel="stylesheet"
          href={window.origin + "/font/Vida/css/vidaicon.css"}
        />
      </Helmet>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <Header />
          <SideBar routes={props.routes} />
          <main
            className={"main-content " + (window.screen.width < 768 && "px-2")}
            style={{
              paddingTop: "102px",
            }}
          >
            {props.children}
          </main>
        </ThemeProvider>
      </CacheProvider>
    </Fragment>
  );
};

export default App;
